import axios from 'axios'
import store from '@/store'
import { getToken, removeToken } from '@/utils/cookieUtil'
// create an axios instance
const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_API,
    timeout: 36000 // request timeout
})

// 生成签名
function generateSignature(url, timestamp) {
    const secret = 'xuanzhuo-blog-2026'
    const data = url + timestamp + secret
    return btoa(data) // 简单的base64编码，实际使用时应该使用更安全的加密方式
}

// 请求频率限制
const requestLimits = {}
function checkRequestLimit(url) {
    const now = Date.now()
    const key = url
    const limit = 20 // 10秒内最多20次请求
    const window = 10000 // 10秒

    if (!requestLimits[key]) {
        requestLimits[key] = []
    }

    // 清理过期的请求记录
    requestLimits[key] = requestLimits[key].filter(time => now - time < window)

    // 检查是否超过限制
    if (requestLimits[key].length >= limit) {
        return false
    }

    // 记录本次请求
    requestLimits[key].push(now)
    return true
}

// request interceptor
service.interceptors.request.use(

    config => {
        // 请求频率限制检查
        if (!checkRequestLimit(config.url)) {
            return Promise.reject(new Error('请求过于频繁，请稍后再试'))
        }

        // 添加安全的请求头
        config.headers['X-Requested-With'] = 'XMLHttpRequest'

        // 添加时间戳和签名
        const timestamp = Date.now()
        config.headers['X-Timestamp'] = timestamp
        config.headers['X-Signature'] = generateSignature(config.url, timestamp)

        // 浏览器指纹识别（简单实现）
        config.headers['X-Browser-Fingerprint'] = navigator.userAgent + navigator.platform + navigator.language

        //do something before request is sent
        let token = getToken()
        if (token != null) {
            // let each request carry token
            // ['X-Token'] is a custom headers key
            // please modify it according to the actual situation
            config.headers.Authorization = token
        }

        return config
    },
    error => {
        // do something with request error
        console.log(error) // for debug
        return Promise.reject(error)
    }
)

// response interceptor
service.interceptors.response.use(
    /**
     * If you want to get http information such as headers or status
     * Please return  response => response
     */

    /**
     * Determine the request status by custom code
     * Here is just an example
     * You can also judge the status by HTTP Status Code
     */
    response => {
        // window.vm.$bus.$emit('hideLoading');
        const res = response.data
        if (response.config.responseType === 'blob' || response.config.responseType === 'arraybuffer') {
            return res
        }
        // store.commit('SET_LOADING',false);
        // if the custom code is not 20000, it is judged as an error.

        if (res.code !== 200) {
            if (res.code == 401) {
                removeToken()
                sessionStorage.removeItem("user")
                store.state.userInfo = null
                store.state.loginFlag = true
            }
            //如果是校验微信登录是否授权的接口 则不进行错误输出
            if (response.config.url !== "/oauth/wechat/is_login") {
                window.vm.$toast.error(res.message);
            }

            return Promise.reject(new Error(res.message || 'Error'))
        } else {
            return res
        }
    },
    error => {
        return Promise.reject(error)
    }
)

export default service
